import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let ClassImprovements = class ClassImprovements extends VuexModule {
    constructor() {
        super(...arguments);
        this.classImprovements = [];
        this.cachedVersion = 0;
    }
    async fetchClassImprovements() {
        const { data: classImprovements, cachedVersion } = await fetchFromCache(this, 'classImprovements', 'classImprovement');
        return { classImprovements, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['classImprovements', 'cachedVersion'] })
], ClassImprovements.prototype, "fetchClassImprovements", null);
ClassImprovements = __decorate([
    Module({ namespaced: true, name: 'classImprovements' })
], ClassImprovements);
export default ClassImprovements;
